import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from '@/plugins/vuetify'
import VueAnalytics from 'vue-analytics'
import './styles/style.scss'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://592afa5290284f468abe8412e72c3f8e@o483106.ingest.sentry.io/5537166",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
// import { StartupService } from 'webview-bridge-web'

Vue.config.productionTip = false

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-163540486-1'
})

// StartupService.start()

new Vue({
  render: h => h(App),
  vuetify,
  router,
  store,
  components: { App }
}).$mount('#app')
